module.exports = __webpack_public_path__ + "d920d005854047e163c624b1aa8ea46e.svg";